import { useMutation } from "urql";

import { UpdateTenantStatusDocument } from "../../../graphql/generated.ts";

export function useUpdateTenantStatus() {
  return useMutation(UpdateTenantStatusDocument);
}
